import { useState } from "react";
import { Link } from "react-router-dom";
import { auth } from "../../fireconnection";
import {sendPasswordResetEmail } from "firebase/auth";
import { toast } from "react-toastify";

export default function ResetPassword() {

    const [email, setEmail] = useState('')

    async function handleResetPassword(e) {

        e.preventDefault()  
        try {
            await sendPasswordResetEmail(auth, email);
            toast.success('Email de redefinição enviado!');
            setEmail('');
        } catch (err) {
            console.error(err);
        }
    }

 return (
    <div className="home-container" >
    <h1>Lista de Tarefas</h1>
    <span>Gerencie suas taredas de forma fácil.</span>
    
    <form className="form" onSubmit={handleResetPassword}>
        <input
            type="email"
            placeholder="Digite seu email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
        />
        
        <button type="submit" >Enviar link de redefinição</button>
        <Link className="button-link" to='/' >Lembrei da minha senha</Link>
    </form>

    <div className="line-ou">
        <hr/> ou <hr/>
    </div>


    <Link to='/register' className="button-link">Não possui uma conta?
        <span> Cadastre-se</span>
    </Link>
   </div>
 );
}